import { removeInvalidOptions } from '../../field-viewer/shared-normalizers';
export const tagsViewer = {
    normalizeLoadedValue: removeInvalidOptions
};

//# sourceMappingURL=definition-viewer.js.map